import { t } from "@lingui/macro";
import { RouteProp, useRoute } from "@react-navigation/native";
import { createNativeStackNavigator } from "@react-navigation/native-stack";
import React from "react";

import { ClubStackNavigatorParamList } from "../../../navigators/ClubNavigator";
import { EventDetailHome } from "./EventDetailHome";

const Stack = createNativeStackNavigator<EventDetailStackNavigatorParamList>();

export const EventDetailStackNavigator = () => {
  const route =
    useRoute<RouteProp<ClubStackNavigatorParamList, "EventDetail">>();
  return (
    <Stack.Navigator
      screenOptions={{
        headerShown: false,
      }}
    >
      <Stack.Screen
        name="EventDetailHome"
        component={EventDetailHome}
        options={{ title: t`Events` }}
        initialParams={{ eventID: route.params.eventID }}
      />
    </Stack.Navigator>
  );
};

export type EventDetailStackNavigatorParamList = {
  EventDetailHome: {
    eventID: string;
  };
  AddGroup: undefined;
  EditForm: {
    eventID: string;
  };
};
